export const s = JSON.stringify;
